module.exports = __webpack_public_path__ + "img/octicon.800079f4.jpg";